<template>
  <main id="main">
<!--    <Loading :isProcessing="isProcessing"></Loading>-->

    <div class="loader">
      <div class="loader__inner">
        <div class="ball-spin-fade-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <p class="loader-text">
          <span>グラフ作成中</span>
          <span>Creating a graph</span>
        </p>
      </div>
    </div>

    <div v-if="!isProcessing">
      <DiagCorpHeader
        v-if="!isRendering"
        :corpName="this.corpName"
        :corporateFeatureInfoLabels="this.corporateFeatureInfoLabels"
        :corporateSelectable="isAdmin"
        :manageCorpName="manageCorpName"
        :isAdmin="isAdmin"
        :isDiagAvailablePlan="isDiagAvailablePlan"
        @select-corporate="emitSelectCorpList"
      ></DiagCorpHeader>
    </div>

    <!-- 通常コンテンツ -->
    <div class="l-contents">
      <h1 class="l-pageTitle"><span class="l-pageLabel">人的資本</span>5年間の推移</h1>

      <div class="l-contentsBox">
        <div class="l-contentsSection">
          <h2 class="l-pageTitle">
            グラフ表示絞り込み
          </h2>
          <div class="human-capitalt-check-all u-mb10">
            <button class="link-arrow js-human-capitalt-check-all-on">全てチェックする</button>
            <button class="link-arrow js-human-capitalt-check-all-off">全てのチェックをはずす</button>
          </div>
          <ul class="human-capitalt-localnav">
            <li><label><input type="checkbox" value="graph14" name="checkbox14" checked="checked">財務情報</label></li>
            <li><label><input type="checkbox" value="graph01" name="checkbox1" checked="checked">採用女性労働者割合</label></li>
            <li><label><input type="checkbox" value="graph02" name="checkbox2" checked="checked">平均継続勤務年数</label></li>
            <li><label><input type="checkbox" value="graph03" name="checkbox3" checked="checked">離職率</label></li>
            <li><label><input type="checkbox" value="graph04" name="checkbox4" checked="checked">女性管理職比率</label></li>
            <li><label><input type="checkbox" value="graph05" name="checkbox5" checked="checked">平均年齢</label></li>
            <li><label><input type="checkbox" value="graph06" name="checkbox6" checked="checked">障がい者雇用率</label></li>
            <li><label><input type="checkbox" value="graph07" name="checkbox7" checked="checked">高年齢者雇用率</label></li>
            <li><label><input type="checkbox" value="graph08" name="checkbox8" checked="checked">労災発生件数</label></li>
            <li><label><input type="checkbox" value="graph09" name="checkbox9" checked="checked">年次有給休暇取得率</label></li>
            <li><label><input type="checkbox" value="graph10" name="checkbox10" checked="checked">1月あたりの平均残業時間</label></li>
            <li><label><input type="checkbox" value="graph11" name="checkbox11" checked="checked">育児休業取得率</label></li>
            <li><label><input type="checkbox" value="graph12" name="checkbox12" checked="checked">介護休業・短時間勤務取得者数</label></li>
            <li><label><input type="checkbox" value="graph13" name="checkbox13" checked="checked">年間平均賃金</label></li>
          </ul>          
        </div>

        <div class="human-capitalt-graph-list">

          <div class="human-capitalt-graph-list__item is-full graph-block graph14">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">財務情報</span>売上高・経常利益・粗利
            </h2>
            <div class="l-contentsGrid2">

              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">売上高</p>
                  <FinancialInformationLineChart
                    ref="financialInfoChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit"
                    class="line-chart-canvas"
                  ></FinancialInformationLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.salesMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.salesMemo.$invalid && !$v.graphMemo.salesMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->

              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">経常利益</p>
                  <FinancialInformationLineChart
                    ref="financialInfoChart3"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="3"
                    :unit="this.unit"
                    class="line-chart-canvas"
                  ></FinancialInformationLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.ordinaryProfitMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.ordinaryProfitMemo.$invalid && !$v.graphMemo.ordinaryProfitMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->

              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">粗利</p>
                  <FinancialInformationLineChart
                    ref="financialInfoChart2"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="2"
                    :unit="this.unit"
                    class="line-chart-canvas"
                  ></FinancialInformationLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.grossProfitMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.grossProfitMemo.$invalid && !$v.graphMemo.grossProfitMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->

            </div><!--/l-contentsGrid2-->
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item is-full graph-block graph01">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">採用</span>採用女性労働者割合
            </h2>    
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <FemalePercentageLineChart
                    ref="femalePercentageChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></FemalePercentageLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.femalePercentageMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.femalePercentageMemo.$invalid && !$v.graphMemo.femalePercentageMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->

            </div><!--/l-contentsGrid2-->
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item is-full graph-block graph02">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">定着</span>平均継続勤務年数
            </h2>
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">男性</p>
                  <EmploymentYearLineChart
                    ref="employmentYearChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit7"
                    class="line-chart-canvas"
                  ></EmploymentYearLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.employmentYearMaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.employmentYearMaleMemo.$invalid && !$v.graphMemo.employmentYearMaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">女性</p>
                  <EmploymentYearLineChart
                    ref="employmentYearChart2"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="2"
                    :unit="this.unit7"
                    class="line-chart-canvas"
                  ></EmploymentYearLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.employmentYearFemaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.employmentYearFemaleMemo.$invalid && !$v.graphMemo.employmentYearFemaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
            </div><!--/l-contentsGrid2-->
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item is-full graph-block graph03">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">定着</span>離職率
            </h2>    
            <div class="l-contentsGrid2">

              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">男性</p>
                  <TurnoverLineChart
                    ref="turnoverChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></TurnoverLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.trunoverMaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.trunoverMaleMemo.$invalid && !$v.graphMemo.trunoverMaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">女性</p>
                  <TurnoverLineChart
                    ref="turnoverChart2"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="2"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></TurnoverLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.trunoverFemaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.trunoverFemaleMemo.$invalid && !$v.graphMemo.trunoverFemaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
            </div><!--/l-contentsGrid2-->
          </div>

          <div class="human-capitalt-graph-list__item is-full graph-block graph04">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">人員構成</span>女性管理職比率
            </h2>    
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10"></p>
                  <FemaleManagerLineChart
                    ref="femaleManagerChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></FemaleManagerLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.femaleManagerMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.femaleManagerMemo.$invalid && !$v.graphMemo.femaleManagerMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
            </div><!--/l-contentsGrid2-->
          </div>

          <div class="human-capitalt-graph-list__item is-full graph-block graph05">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">人員構成</span>平均年齢
            </h2>    
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">男性</p>
                  <AgeAverageLineChart
                    ref="ageAverageChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit3"
                    class="line-chart-canvas"
                  ></AgeAverageLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.ageAverageMaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.ageAverageMaleMemo.$invalid && !$v.graphMemo.ageAverageMaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">女性</p>
                  <AgeAverageLineChart
                    ref="ageAverageChart2"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="2"
                    :unit="this.unit3"
                    class="line-chart-canvas"
                  ></AgeAverageLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.ageAverageFemaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.ageAverageFemaleMemo.$invalid && !$v.graphMemo.ageAverageFemaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
            </div><!--/l-contentsGrid2-->
          </div>

          <div class="human-capitalt-graph-list__item graph-block graph06">
            <div class="u-mb40">
              <h2 class="l-pageTitle">
                <span class="l-pageLabel">人員構成</span>障がい者雇用率
              </h2>
              <DisabilitiesRateLineChart
                ref="disabilitiesRateChart"
                :startYear="this.startYear"
                :corpId="this.corpId"
                :dataType="1"
                :unit="this.unit2"
                class="line-chart-canvas"
              ></DisabilitiesRateLineChart>
              <div class="l-formGroup u-mt10">
                <label class="l-formGroup__label u-mb10">メモ</label>
                <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.disabilitiesRateMemo" @input="changeInput()"></TextArea>
                <ValidationErrorMessage v-show="$v.graphMemo.disabilitiesRateMemo.$invalid && !$v.graphMemo.disabilitiesRateMemo.maxLength" validation="maxLength" valueLength="300" />
              </div>
            </div>
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item graph-block graph07">
            <div class="u-mb40">
              <h2 class="l-pageTitle">
                <span class="l-pageLabel">人員構成</span>高年齢者雇用率
              </h2>
              <ElderlyRateLineChart
                ref="elderlyRateChart"
                :startYear="this.startYear"
                :corpId="this.corpId"
                :unit="this.unit2"
                class="line-chart-canvas"
              ></ElderlyRateLineChart>
              <div class="l-formGroup u-mt10">
                <label class="l-formGroup__label u-mb10">メモ</label>
                <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.elderlyRateMemo" @input="changeInput()"></TextArea>
                <ValidationErrorMessage v-show="$v.graphMemo.elderlyRateMemo.$invalid && !$v.graphMemo.elderlyRateMemo.maxLength" validation="maxLength" valueLength="300" />
              </div>
            </div>
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item graph-block graph08">
            <div class="u-mb40">
              <h2 class="l-pageTitle">
                <span class="l-pageLabel">安全衛生</span>労災発生件数
              </h2>
              <AccidentsCountLineChart
                ref="accidentCountChart"
                :startYear="this.startYear"
                :corpId="this.corpId"
                :unit="this.unit4"
                class="line-chart-canvas"
              ></AccidentsCountLineChart>
              <div class="l-formGroup u-mt10">
                <label class="l-formGroup__label u-mb10">メモ</label>
                <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.accidentsCountMemo" @input="changeInput()"></TextArea>
                <ValidationErrorMessage v-show="$v.graphMemo.accidentsCountMemo.$invalid && !$v.graphMemo.accidentsCountMemo.maxLength" validation="maxLength" valueLength="300" />
              </div>
            </div>
          </div><!--/human-capitalt-graph-list__item-->
          <div class="human-capitalt-graph-list__item is-full graph-block graph09">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">労働条件</span>年次有給休暇取得率
            </h2>    
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">正社員</p>
                  <AcquisitionRateLineChart
                    ref="acquisitionRateChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></AcquisitionRateLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.acquisitionRateRegularMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.acquisitionRateRegularMemo.$invalid && !$v.graphMemo.acquisitionRateRegularMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">非正規社員</p>
                  <AcquisitionRateLineChart
                    ref="acquisitionRateChart2"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="2"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></AcquisitionRateLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.acquisitionRateNonRegularMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.acquisitionRateNonRegularMemo.$invalid && !$v.graphMemo.acquisitionRateNonRegularMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
            </div><!--/l-contentsGrid2-->
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item graph-block graph10">
            <div class="u-mb40">
              <h2 class="l-pageTitle">
                <span class="l-pageLabel">労働条件</span>1月あたりの平均残業時間
              </h2>
              <WorkingAverageLineChart
                ref="workingAverageChart"
                :startYear="this.startYear"
                :corpId="this.corpId"
                :dataType="1"
                :unit="this.unit5"
                class="line-chart-canvas"
              ></WorkingAverageLineChart>
              <div class="l-formGroup u-mt10">
                <label class="l-formGroup__label u-mb10">メモ</label>
                <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.workingAverageMemo" @input="changeInput()"></TextArea>
                <ValidationErrorMessage v-show="$v.graphMemo.workingAverageMemo.$invalid && !$v.graphMemo.workingAverageMemo.maxLength" validation="maxLength" valueLength="300" />
              </div>
            </div>
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item is-full graph-block graph11">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">育児介護休業</span>育児休業取得率
            </h2>
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">男性</p>
                  <ChildcareRateLineChart
                    ref="childcareRateChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></ChildcareRateLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.childcareRateMaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.childcareRateMaleMemo.$invalid && !$v.graphMemo.childcareRateMaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">女性</p>
                  <ChildcareRateLineChart
                    ref="childcareRateChart2"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="2"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></ChildcareRateLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.childcareRateFemaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.childcareRateFemaleMemo.$invalid && !$v.graphMemo.childcareRateFemaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">全社</p>
                  <ChildcareRateLineChart
                    ref="childcareRateChart3"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="3"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></ChildcareRateLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.childcareRateCorpMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.childcareRateCorpMemo.$invalid && !$v.graphMemo.childcareRateCorpMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
            </div>
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item graph-block graph12">
            <div class="u-mb40">
              <h2 class="l-pageTitle">
                <span class="l-pageLabel">育児介護休業</span>介護休業・短時間勤務取得者数
              </h2>
              <NursingCareLeaveLineChart
                ref="nursingCareLeaveChart"
                :startYear="this.startYear"
                :corpId="this.corpId"
                :unit="this.unit6"
                class="line-chart-canvas"
              ></NursingCareLeaveLineChart>
              <div class="l-formGroup u-mt10">
                <label class="l-formGroup__label u-mb10">メモ</label>
                <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.nursingCareRateMemo" @input="changeInput()"></TextArea>
                <ValidationErrorMessage v-show="$v.graphMemo.nursingCareRateMemo.$invalid && !$v.graphMemo.nursingCareRateMemo.maxLength" validation="maxLength" valueLength="300" />
              </div>
            </div>
          </div><!--/human-capitalt-graph-list__item-->

          <div class="human-capitalt-graph-list__item is-full graph-block graph13">
            <h2 class="l-pageTitle">
              <span class="l-pageLabel">賃金</span>年間平均賃金
            </h2>
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">男性</p>
                  <WageAverageLineChart
                    ref="wageAverageChart"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="1"
                    :unit="this.unit"
                    class="line-chart-canvas"
                  ></WageAverageLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.wageAverageMaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.wageAverageMaleMemo.$invalid && !$v.graphMemo.wageAverageMaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">女性</p>
                  <WageAverageLineChart
                    ref="wageAverageChart2"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="2"
                    :unit="this.unit"
                    class="line-chart-canvas"
                  ></WageAverageLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.wageAverageFemaleMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.wageAverageFemaleMemo.$invalid && !$v.graphMemo.wageAverageFemaleMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->
              <div class="l-contentsGrid2__item u-mb40">
                <div>
                  <p class="l-formGroup__label u-mb10">賃金差異</p>
                  <WageAverageLineChart
                    ref="wageAverageChart3"
                    :startYear="this.startYear"
                    :corpId="this.corpId"
                    :dataType="3"
                    :unit="this.unit2"
                    class="line-chart-canvas"
                  ></WageAverageLineChart>
                  <div class="l-formGroup u-mt10">
                    <label class="l-formGroup__label u-mb10">メモ</label>
                    <TextArea class="l-formGroup__textArea is-mini" v-model="graphMemo.wageAverageDiffMemo" @input="changeInput()"></TextArea>
                    <ValidationErrorMessage v-show="$v.graphMemo.wageAverageDiffMemo.$invalid && !$v.graphMemo.wageAverageDiffMemo.maxLength" validation="maxLength" valueLength="300" />
                  </div>
                </div>
              </div><!--/l-contentsGrid2__item"-->

            </div><!--/l-contentsGrid2-->
          </div> <!-- human-capitalt-graph-list end -->
        </div><!--/human-capitalt-graph-list-->

        <div class="l-contentsBox__bottom u-tac js-fixedBarBottom-hide">
          <div class="btn-basic is-inlne is-primary js-save"><button @click="save">メモを保存する</button></div>
        </div>
      </div>
    </div>

    <div class="l-fixedBarBottom">
      <div class="is-center">
        <div class="btn-basic is-inlne is-primary js-save"><button @click="save">メモを保存する</button></div>
      </div>
    </div>

  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import TextArea from '@/components/parts/form/TextArea.vue';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';
import { maxLength } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
//import Loading from '@/components/parts/common/Loading.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import FinancialInformationLineChart from '@/components/parts/human_capital/parts/FinancialInformationLineChart.vue';
import FemalePercentageLineChart from '@/components/parts/human_capital/parts/FemalePercentageLineChart.vue';
import EmploymentYearLineChart from '@/components/parts/human_capital/parts/EmploymentYearLineChart.vue';
import AgeAverageLineChart from '@/components/parts/human_capital/parts/AgeAverageLineChart.vue';
import FemaleManagerLineChart from '@/components/parts/human_capital/parts/FemaleManagerLineChart.vue';
import TurnoverLineChart from '@/components/parts/human_capital/parts/TurnoverLineChart.vue';
import DisabilitiesRateLineChart from '@/components/parts/human_capital/parts/DisabilitiesRateLineChart.vue';
import ElderlyRateLineChart from '@/components/parts/human_capital/parts/ElderlyRateLineChart.vue';
import AccidentsCountLineChart from '@/components/parts/human_capital/parts/AccidentsCountLineChart.vue';
import AcquisitionRateLineChart from '@/components/parts/human_capital/parts/AcquisitionRateLineChart.vue';
import ChildcareRateLineChart from '@/components/parts/human_capital/parts/ChildcareRateLineChart.vue';
import NursingCareLeaveLineChart from '@/components/parts/human_capital/parts/NursingCareLeaveLineChart.vue';
import WageAverageLineChart from '@/components/parts/human_capital/parts/WageAverageLineChart.vue';
import WorkingAverageLineChart from '@/components/parts/human_capital/parts/WorkingAverageLineChart.vue';

export default {
  components: {
//    Loading,
    DiagCorpHeader,
    TextArea,
    Currency,
    ValidationErrorMessage,
    FinancialInformationLineChart,
    FemalePercentageLineChart,
    EmploymentYearLineChart,
    AgeAverageLineChart,
    FemaleManagerLineChart,
    TurnoverLineChart,
    DisabilitiesRateLineChart,
    ElderlyRateLineChart,
    AccidentsCountLineChart,
    AcquisitionRateLineChart,
    ChildcareRateLineChart,
    NursingCareLeaveLineChart,
    WageAverageLineChart,
    WorkingAverageLineChart,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      isAnswerChanged: false,

      isAdmin: false,
      isDiagAvailablePlan: false,
      startYear: null,
      unit: '千円',
      unit2:'％',
      unit3:'歳',
      unit4:'件',
      unit5:'時間',
      unit6:'名',
      unit7:'年',

      graphMemo: {},

      corpNm: '',
      corporateFeatureInfoLabels: {},
    }
  },
  validations: {
    graphMemo: {
      salesMemo: { maxLength: maxLength(300) },
      grossProfitMemo: { maxLength: maxLength(300) },
      ordinaryProfitMemo: { maxLength: maxLength(300) },
      femalePercentageMemo: { maxLength: maxLength(300) },
      employmentYearMaleMemo: { maxLength: maxLength(300) },
      employmentYearFemaleMemo: { maxLength: maxLength(300) },
      trunoverMaleMemo: { maxLength: maxLength(300) },
      trunoverFemaleMemo: { maxLength: maxLength(300) },
      femaleManagerMemo: { maxLength: maxLength(300) },
      ageAverageMaleMemo: { maxLength: maxLength(300) },
      ageAverageFemaleMemo: { maxLength: maxLength(300) },
      disabilitiesRateMemo: { maxLength: maxLength(300) },
      elderlyRateMemo: { maxLength: maxLength(300) },
      accidentsCountMemo: { maxLength: maxLength(300) },
      acquisitionRateRegularMemo: { maxLength: maxLength(300) },
      acquisitionRateNonRegularMemo: { maxLength: maxLength(300) },
      workingAverageMemo: { maxLength: maxLength(300) },
      childcareRateMaleMemo: { maxLength: maxLength(300) },
      childcareRateFemaleMemo: { maxLength: maxLength(300) },
      childcareRateCorpMemo: { maxLength: maxLength(300) },
      nursingCareRateMemo: { maxLength: maxLength(300) },
      wageAverageMaleMemo: { maxLength: maxLength(300) },
      wageAverageFemaleMemo: { maxLength: maxLength(300) },
      wageAverageDiffMemo: { maxLength: maxLength(300) },
    }
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
//    corporateFeatureInfoLabels() {
//      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
//    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  mounted: function() {
    jQuery(function ($) {
      $('.js-human-capitalt-check-all-on').on('click', function() {
        $('.human-capitalt-localnav input[type="checkbox"]').prop('checked', true);
        $('.graph-block').show();
      });
      $('.js-human-capitalt-check-all-off').on('click', function() {
        $('.human-capitalt-localnav input[type="checkbox"]').prop('checked', false);
        $('.graph-block').hide();
      });
      function toggleElements() {
        $('.human-capitalt-localnav input[type="checkbox"]').each(function() {
          var checkbox = $(this);
          var targetClass = checkbox.val();
          if (checkbox.is(':checked')) {
            $('.' + targetClass).show();
          } else {
            $('.' + targetClass).hide();
          }
        });
      }
      $(window).on('load', toggleElements);
      $('.human-capitalt-localnav input[type="checkbox"]').on('change', toggleElements);


      $(window).on('scroll load', function () {
        // ウィンドウの高さとスクロール量を取得
        var windowHeight = $(window).height();
        var scrollAmount = $(window).scrollTop();

        // '.js-fixedBarBottom-hide' 要素の位置を取得
        if($('.js-fixedBarBottom-hide').length){

          var elementOffset = $('.js-fixedBarBottom-hide').offset().top;

          // ウィンドウ内に要素があるかチェック
          if (scrollAmount + windowHeight > elementOffset) {
              // 要素が見えたら '.l-fixedBarBottom' を非表示にする
              $('.l-fixedBarBottom').removeClass('is-show');
          } else {
              // 要素が見えないときは '.l-fixedBarBottom' を表示する
              $('.l-fixedBarBottom').addClass('is-show');
          }
        }
      });

/*      setTimeout(function() {
        $('body').removeClass('loading');
        $('.loader').addClass('hide');
        $('.loader').fadeOut();
      }, 10000);*/
    });
  },
  created: async function () {

    this.isProcessing = true;
    this.isRendering = true;

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

    // パラメータのチェック
    await this.checkParams(this.$route.params);

    $('body').removeClass('loading');
    $('.loader').addClass('hide');
    $('.loader').fadeOut();
 
    this.isProcessing = false;

    this.isRendering = false;
  },
  /**
   * 画面遷移前　編集項目確認
   */
  beforeRouteLeave (to, from, next) {
    if (this.isAnswerChanged) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？");
      if ( answer ) {
        this.isAnswerChanged = false;
        next(answer);
      }
    } else {
      next();
    }
  },
  methods: {

    /**
     * 保存処理
     */
    async save() {
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/hr/saveGraphMemo', {
          corpId: this.corpId,          
          graphMemo: this.graphMemo,
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          this.isAnswerChanged = false;
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }else {
        this.$toast.error('入力データが不正です。');
      }
    },
    /**
     * パラメータチェック
     */
    async checkParams(params) {
      let res = await this.$axios.post('/ld/api/hr/checkParams', { corpId: params.corpId, });
      if (res.status === 500) {
        // checkParamsでエラーになったときは、正常なcorpIdが引き継がれていなかったということで、人的資本管理TOP画面に遷移する
        let corpListRet = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
        if (corpListRet) {
          if (this.corpId == null) {
            this.$store.dispatch('diag/setCorpId', corpListRet.data.corporateList[0].corpId);
            this.$store.dispatch('diag/setDiagResultId', null);
            this.$store.dispatch('diag/setDiagResultItemId', null);
          }
          this.$toast.error('企業情報が見つからなかったので、Top画面に戻ります。');
          this.$router.replace({path: '/hr/'+this.corpId+'/topparam'});
          this.isProcessing = false;
        }
      }else{
        if ( this.corpId !== params.corpId ){
          this.$store.dispatch('diag/setCorpId', params.corpId);
          this.$store.dispatch('diag/setDiagResultId', null);
          this.$store.dispatch('diag/setDiagResultItemId', null);
        }
        await this.getCorporateInfo(this.corpId);
        await this.getGraphMemo(this.corpId);
      }
    },
    async getCorporateInfo(corpId) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/hr/getCorporateFeatureInfoLabels', {
          corpId: corpId,
        });
        if (res.status == 200) {
          this.corpNm = res.data.corporateName;
          this.$store.dispatch('diag/setCorpName', this.corpNm);

          this.corporateFeatureInfoLabels = res.data.corporateFeatureInfoLabels;
          await this.getSummaryGraphData(this.corpId);
        }else{
          this.$toast.error(res.data.message);
          this.isProcessing = false;
        }
      }
    },
    async getGraphMemo(corpId) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/hr/getGraphMemo', {
          corpId: corpId,
        });
        if (res.status == 200) {
          this.graphMemo = res.data.graphMemo;
        }else{
          this.$toast.error(res.data.message);
          this.isProcessing = false;
        }
      }
    },
    async getSummaryGraphData(corpId) {
      if ( corpId ) {
        let res = await this.$axios.post('/ld/api/hr/getSummaryGraphData', {
          corpId: corpId,
        });
        if (res.status == 200) {
          this.startYear = res.data.startYear;
          await this.updateCharts(this.corpId, this.startYear);
        }else{
          this.isProcessing = false;
          this.$toast.error(res.data.message);
        }
      }
    },
    /**
     * グラフを更新します
     */
    async updateCharts(corpId, year){
      // 財務情報
      if (this.$refs.financialInfoChart) await this.$refs.financialInfoChart.recreateChart(corpId, year); // 財務情報（売上高）
      if (this.$refs.financialInfoChart3) await this.$refs.financialInfoChart3.recreateChart(corpId,year);// 財務情報（経常利益）
      if (this.$refs.financialInfoChart2) await this.$refs.financialInfoChart2.recreateChart(corpId,year);// 財務情報（粗利）
      // 採用女性労働者割合
      if (this.$refs.femalePercentageChart) await this.$refs.femalePercentageChart.recreateChart(corpId, year); // 採用女性労働者割合
      // 平均継続勤務年数
      if (this.$refs.employmentYearChart) await this.$refs.employmentYearChart.recreateChart(corpId,year); // 平均継続勤務年数（男性）
      if (this.$refs.employmentYearChart2) await this.$refs.employmentYearChart2.recreateChart(corpId,year); // 平均継続勤務年数（女性）
      // 離職率
      if (this.$refs.turnoverChart) await this.$refs.turnoverChart.recreateChart(corpId, year); // 離職率（男性）
      if (this.$refs.turnoverChart2) await this.$refs.turnoverChart2.recreateChart(corpId,year); // 離職率（女性）
      // 女性管理職比率
      if (this.$refs.femaleManagerChart) await this.$refs.femaleManagerChart.recreateChart(corpId,year); // 女性管理職比率
      // 平均年齢
      if (this.$refs.ageAverageChart) await this.$refs.ageAverageChart.recreateChart(corpId, year); // 平均年齢（男性）
      if (this.$refs.ageAverageChart2) await this.$refs.ageAverageChart2.recreateChart(corpId,year); // 平均年齢（女性）
      // 障がい者雇用率
      if (this.$refs.disabilitiesRateChart) await this.$refs.disabilitiesRateChart.recreateChart(corpId,year); // 障がい者雇用率
      // 高年齢者雇用率
      if (this.$refs.elderlyRateChart) await this.$refs.elderlyRateChart.recreateChart(corpId, year); // 高年齢者雇用率
      // 労災発生件数
      if (this.$refs.accidentCountChart) await this.$refs.accidentCountChart.recreateChart(corpId,year); // 労災発生件数
      // 年次有給休暇取得率
      if (this.$refs.acquisitionRateChart) await this.$refs.acquisitionRateChart.recreateChart(corpId,year); // 年次有給休暇取得率（正社員）
      if (this.$refs.acquisitionRateChart2) await this.$refs.acquisitionRateChart2.recreateChart(corpId, year); // 年次有給休暇取得率（非正規社員）
      // 1月あたりの平均残業時間
      if (this.$refs.workingAverageChart) await this.$refs.workingAverageChart.recreateChart(corpId,year); // 1月あたりの平均残業時間
      // 育児休業取得率
      if (this.$refs.childcareRateChart) await this.$refs.childcareRateChart.recreateChart(corpId,year); // 育児休業取得率(男性)
      if (this.$refs.childcareRateChart2) await this.$refs.childcareRateChart2.recreateChart(corpId,year); // 育児休業取得率(女性)
      if (this.$refs.childcareRateChart3) await this.$refs.childcareRateChart3.recreateChart(corpId,year); // 育児休業取得率(全社)
      // 介護休業・短時間勤務取得者数
      if (this.$refs.nursingCareLeaveChart) await this.$refs.nursingCareLeaveChart.recreateChart(corpId,year); // 介護休業・短時間勤務取得者数
      // 年間平均賃金
      if (this.$refs.wageAverageChart) await this.$refs.wageAverageChart.recreateChart(corpId,year); // 年間平均賃金（男性）
      if (this.$refs.wageAverageChart2) await this.$refs.wageAverageChart2.recreateChart(corpId,year); // 年間平均賃金（女性）
      if (this.$refs.wageAverageChart3) await this.$refs.wageAverageChart3.recreateChart(corpId, year); // 年間平均賃金（賃金差異）

    },
    async emitSelectCorpList(params) {
      this.isProcessing = false;
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);

      this.$router.replace({name: 'hr-summary-graph', params: { corpId: this.corpId }});
      this.$router.go({path: this.$router.currentRoute.path, force: true})

      if (!this.isSupple) {
        await this.getCorporateInfo(this.corpId);
        await this.getGraphMemo(this.corpId);
      }

      this.$nextTick(() => {
        this.isProcessing = false;
      });
    },
    /**
     * 値編集チェック用フラグ
     */
    changeInput(){
      this.isAnswerChanged = true
    },

  }
}
</script>
